import { useState } from 'react';

/**
 * The record a detail drawer should RENDER, holding the last live one after
 * it disappears — Base UI keeps a closing drawer mounted through its exit
 * transition, and a delete's refetch can drop the record from the data
 * mid-slide, leaving nothing to animate out.
 *
 * Written during render (React's sanctioned previous-value pattern); actions
 * must keep reading the LIVE record, so nothing can act on one already gone.
 * One hook for every drawer that needs the choreography (deliveries, stock)
 * instead of a hand-rolled held-state pair per record type.
 */
export function useHeldRecord<T>(live: T | null): T | null {
  const [held, setHeld] = useState<T | null>(null);
  if (live && live !== held) setHeld(live);
  return live ?? held;
}
